import { get, flow, omitBy, isEqual } from 'lodash/fp';
import { replace as replaceRoute } from 'connected-react-router';

import {
  formToQuery,
  formScaffolding,
  initSearchLayout,
  stringifyAdsQuery,
} from 'components/searchAds';
import { selectCarMakeById } from 'store/ducks/manufacturers';
import getExperimentsWithWinnerVariant from 'helpers/getExperimentsWithWinnerVariant';
import { COOKIE_SEARCH_RESULTS_EXP } from 'constants/gaExperiment';
import { setExperiment } from 'components/experiment/actions';
import mapStateToProps from '../mapStateToProps';
import { cmsDuck } from '../duck';
import {
  getCmsExperimentData,
  getNumberOfResultsExpResult,
} from '../selectors';

const changeFilters = (form) =>
  function* ({ getState }) {
    const carMakeById = selectCarMakeById(getState());
    const query = flow(
      omitBy((value, key) => isEqual(formScaffolding[key], value)),
      formToQuery(carMakeById),
    )(form);
    const nextLocation = {
      search: stringifyAdsQuery(query),
      query,
    };

    yield replaceRoute(nextLocation);

    return nextLocation;
  };

const setExperimentsDuckFromCookie = () =>
  function* ({ getState, cookies }) {
    const experimentsWithWinnerVariant = getExperimentsWithWinnerVariant(
      getCmsExperimentData(getState()),
    );
    const numberOfResults = get(
      ['numberOfResults'],
      experimentsWithWinnerVariant,
    );

    if (numberOfResults) {
      yield setExperiment(COOKIE_SEARCH_RESULTS_EXP, numberOfResults);
    } else {
      yield cookies.set(COOKIE_SEARCH_RESULTS_EXP, null, -1);
    }
  };

const persistExperimentsCookie = () =>
  function* ({ cookies, getState }) {
    const searchResultsExp = getNumberOfResultsExpResult(getState());

    if (searchResultsExp && !cookies.get(COOKIE_SEARCH_RESULTS_EXP)) {
      yield cookies.set(
        COOKIE_SEARCH_RESULTS_EXP,
        JSON.stringify(searchResultsExp),
      );
    }
  };

const changePage = changeFilters;
const changeSort = changeFilters;

const fetch = () =>
  function* ({ getState, getCurrentLocation }) {
    yield cmsDuck.load('search');
    yield setExperimentsDuckFromCookie();
    yield persistExperimentsCookie();

    const props = mapStateToProps(getState(), {
      location: getCurrentLocation(),
    });

    yield initSearchLayout(props);
  };

export default {
  fetch,
  changePage,
  changeSort,
  changeFilters,
};
